const Rates = {
  EUR: { rate: 0.33, currency: "EUR" },
  USD: { rate: 0.31, currency: "USD" },
  UK: { rate: 0.41, currency: "GBP" },
};

const countriesRate = {
  FR: Rates.EUR, // France
  IT: Rates.EUR,
  AT: Rates.EUR, // Aur
  BE: Rates.EUR, // Belgium
  CZ: Rates.EUR,
  DK: Rates.EUR, // Denmark
  FI: Rates.EUR, // Finland
  DE: Rates.EUR, // Germany
  IE: Rates.EUR, // Ireland
  NL: Rates.EUR, // Netherland
  PL: Rates.EUR, // Poland
  PT: Rates.EUR, // Portugal
  ES: Rates.EUR, // Spain
  SE: Rates.EUR, // sweden
  JO: Rates.USD,
  CH: Rates.USD,
  NZ: Rates.USD,
  NO: Rates.USD,
  AU: Rates.USD,
  AF: Rates.USD,
  AX: Rates.USD,
  AL: Rates.USD,
  DZ: Rates.USD,
  AD: Rates.USD,
  AO: Rates.USD,
  AI: Rates.USD,
  AG: Rates.USD,
  AR: Rates.USD,
  AM: Rates.USD,
  AW: Rates.USD,
  AC: Rates.USD,
  AZ: Rates.USD,
  BS: Rates.USD,
  BH: Rates.USD,
  BD: Rates.USD,
  BB: Rates.USD,
  BY: Rates.USD,
  BZ: Rates.USD,
  BJ: Rates.USD,
  BM: Rates.USD,
  BT: Rates.USD,
  BO: Rates.USD,
  BA: Rates.USD,
  BW: Rates.USD,
  BR: Rates.USD,
  IO: Rates.USD,
  VG: Rates.USD,
  BN: Rates.USD,
  BG: Rates.EUR, // Bulgaria
  BF: Rates.USD,
  BI: Rates.USD,
  KH: Rates.USD,
  CM: Rates.USD,
  CA: Rates.USD,
  CV: Rates.USD,
  BQ: Rates.USD,
  KY: Rates.USD,
  CF: Rates.USD,
  TD: Rates.USD,
  CL: Rates.USD,
  CN: Rates.USD,
  CX: Rates.USD,
  CC: Rates.USD,
  CO: Rates.USD,
  KM: Rates.USD,
  CG: Rates.USD,
  CD: Rates.USD,
  CK: Rates.USD,
  CR: Rates.USD,
  CI: Rates.USD,
  HR: Rates.EUR, // Croatia
  CW: Rates.USD,
  CY: Rates.EUR, // cypurs
  DJ: Rates.USD,
  DM: Rates.USD,
  DO: Rates.USD,
  EC: Rates.USD,
  EG: Rates.USD,
  SV: Rates.USD,
  GQ: Rates.USD,
  ER: Rates.USD,
  EE: Rates.EUR, // Estonia
  SZ: Rates.USD,
  ET: Rates.USD,
  FK: Rates.USD,
  FO: Rates.USD,
  FJ: Rates.USD,
  GF: Rates.USD,
  PF: Rates.USD,
  TF: Rates.USD,
  GA: Rates.USD,
  GM: Rates.USD,
  GE: Rates.USD,
  GH: Rates.USD,
  GI: Rates.USD,
  GR: Rates.EUR, // Greece
  GL: Rates.USD,
  GD: Rates.USD,
  GP: Rates.USD,
  GT: Rates.USD,
  GG: Rates.USD,
  GN: Rates.USD,
  GW: Rates.USD,
  GY: Rates.USD,
  HT: Rates.USD,
  HN: Rates.USD,
  HK: Rates.USD,
  HU: Rates.EUR, // Hungary
  IS: Rates.USD,
  IN: Rates.USD,
  ID: Rates.USD,
  IQ: Rates.USD,
  IM: Rates.USD,
  IL: Rates.USD,
  IT: Rates.EUR, // Italy
  JM: Rates.USD,
  JP: Rates.USD,
  JE: Rates.USD,
  KZ: Rates.USD,
  KE: Rates.USD,
  KI: Rates.USD,
  XK: Rates.USD,
  KW: Rates.USD,
  KG: Rates.USD,
  LA: Rates.USD,
  LV: Rates.EUR, // Lativa
  LB: Rates.USD,
  LS: Rates.USD,
  LR: Rates.USD,
  LY: Rates.USD,
  LI: Rates.USD,
  LT: Rates.EUR, // Lithunia
  LU: Rates.EUR, // Luxe
  MO: Rates.USD,
  MG: Rates.USD,
  MW: Rates.USD,
  MY: Rates.USD,
  MV: Rates.USD,
  ML: Rates.USD,
  MT: Rates.EUR, // Malt
  MQ: Rates.USD,
  MR: Rates.USD,
  MU: Rates.USD,
  YT: Rates.USD,
  MX: Rates.USD,
  MD: Rates.USD,
  MC: Rates.USD,
  MN: Rates.USD,
  ME: Rates.USD,
  MS: Rates.USD,
  MA: Rates.USD,
  MZ: Rates.USD,
  MM: Rates.USD,
  NA: Rates.USD,
  NR: Rates.USD,
  NP: Rates.USD,
  NC: Rates.USD,
  NI: Rates.USD,
  NE: Rates.USD,
  NG: Rates.USD,
  NU: Rates.USD,
  NF: Rates.USD,
  MK: Rates.USD,
  OM: Rates.USD,
  PK: Rates.USD,
  PS: Rates.USD,
  PA: Rates.USD,
  PG: Rates.USD,
  PY: Rates.USD,
  PE: Rates.USD,
  PH: Rates.USD,
  PN: Rates.USD,
  QA: Rates.USD,
  RE: Rates.USD,
  RO: Rates.EUR, // Romania
  RU: Rates.USD,
  RW: Rates.USD,
  WS: Rates.USD,
  SM: Rates.USD,
  ST: Rates.USD,
  SA: Rates.USD,
  SN: Rates.USD,
  RS: Rates.USD,
  SC: Rates.USD,
  SL: Rates.USD,
  SG: Rates.USD,
  SX: Rates.USD,
  SK: Rates.EUR, // Slovenkia
  SI: Rates.EUR, // Slovenia
  SB: Rates.USD,
  SO: Rates.USD,
  ZA: Rates.USD,
  GS: Rates.USD,
  KR: Rates.USD,
  SS: Rates.USD,
  LK: Rates.USD,
  BL: Rates.USD,
  SH: Rates.USD,
  KN: Rates.USD,
  LC: Rates.USD,
  MF: Rates.USD,
  PM: Rates.USD,
  VC: Rates.USD,
  SD: Rates.USD,
  SR: Rates.USD,
  SJ: Rates.USD,
  TW: Rates.USD,
  TJ: Rates.USD,
  TZ: Rates.USD,
  TH: Rates.USD,
  TL: Rates.USD,
  TG: Rates.USD,
  TK: Rates.USD,
  TO: Rates.USD,
  TT: Rates.USD,
  TA: Rates.USD,
  TN: Rates.USD,
  TR: Rates.USD,
  TM: Rates.USD,
  TC: Rates.USD,
  TV: Rates.USD,
  UM: Rates.USD,
  UG: Rates.USD,
  UA: Rates.USD,
  AE: Rates.USD,
  US: Rates.USD,
  UY: Rates.USD,
  UZ: Rates.USD,
  VU: Rates.USD,
  VA: Rates.USD,
  VE: Rates.USD,
  VN: Rates.USD,
  WF: Rates.USD,
  EH: Rates.USD,
  YE: Rates.USD,
  ZM: Rates.USD,
  ZW: Rates.USD,
  US: Rates.USD,
  GB: Rates.UK,
  BH: { rate: 0.81, currency: "BHD" },
  KW: { rate: 1, currency: "KWD" },
  OM: { rate: 0.8, currency: "OMR" },
  QA: { rate: 0.084, currency: "QAR" },
  SA: { rate: 0.082, currency: "SAR" },
  AE: { rate: 0.083, currency: "AED" },
  JO: { rate: 0.71, currency: "USD" },
  default: { rate: 1, currency: "QAR" },
};

const countiresISO = Object.keys(countriesRate);

const replaceCurrency = "AED";
const replaceLanguage = "د.إ";

const toggleCountry = (countryCode, currency, toggleId) => {
  const toggleIdName = `${toggleId}-${countryCode?.toLowerCase()}`;
  const toggleElement = document.getElementById(toggleIdName);
  if (toggleElement) {
    let replacingCurrencyElement = toggleElement?.textContent
      ?.replace(replaceCurrency, ` ${currency?.toUpperCase()}`)
      ?.trim();
    let replacinglanguageElement = replacingCurrencyElement?.replace(
      replaceLanguage,
      " "
    );

    if (replacinglanguageElement?.split(" ").includes("Italy")) {
      replacinglanguageElement = replacinglanguageElement?.replace(
        "Italy",
        "European Union"
      );
    } else if (replacinglanguageElement?.split(" ").includes("Afghanistan")) {
      replacinglanguageElement = replacinglanguageElement?.replace(
        "Afghanistan",
        "Worldwide"
      );
    }

    if (toggleId === "drawer-menu__link--label") {
      toggleElement.innerHTML = `${replacinglanguageElement}`;
    } else {
      toggleElement.innerHTML = `<span class="flag-icon flag-icon-${
        countryCode?.toLowerCase() === "af" ? "us" : countryCode?.toLowerCase()
      }"></span> ${replacinglanguageElement}`;
    }
  }
};

const updateCountryFlag = (toggleId, spanId) => {
  for (
    let countiresIndex = 0;
    countiresIndex < countiresISO?.length;
    countiresIndex++
  ) {
    const countryCode = countiresISO[countiresIndex];
    const currency = countriesRate[countryCode]?.currency;
    toggleCountry(countryCode, currency, toggleId);

    const id = `${spanId}-${countryCode?.toUpperCase()}`; // disclosure-list__option-label drawer-menu__item localization-item
    const countryElement = document.getElementById(id);
    const replacingCurrencyElement = countryElement?.textContent
      ?.replace(replaceCurrency, ` ${currency?.toUpperCase()}`)
      ?.trim();
    const replacinglanguageElement = replacingCurrencyElement?.replace(
      replaceLanguage,
      " "
    );
    if (countryElement) countryElement.innerHTML = replacinglanguageElement;
  }
};

const reducesCountries = (id) => {
  var currencyList = document.getElementById(id);
  var listItems = currencyList.getElementsByTagName("li");
  let hasWorldwide = false;
  // Loop through list items and remove those containing "EUR"
  for (var i = listItems.length - 1; i >= 0; i--) {
    var label = listItems[i].getElementsByTagName("span")[1];

    if (label?.textContent?.includes("Italy")) {
      // EUR
      label.textContent = "European Union ( EUR )";
    } else if (label && label?.textContent?.includes("EUR")) {
      currencyList?.removeChild(listItems[i]);
    }
    if (label?.textContent?.includes("Afghanistan")) {
      let country = listItems[i].getElementsByTagName("span")[0];
      country.className = "flag-icon flag-icon-us";
      label.textContent = "Worldwide (USD)";
    } else if (
      label &&
      label.textContent.includes("USD") &&
      !label.textContent.includes("Jordan") &&
      !label?.textContent?.includes("United States")
    ) {
      // Remove other USD countries except Jordan
      currencyList?.removeChild(listItems[i]);
    }

    
    const anchor = listItems[i].getElementsByTagName("a")[0];
    const countryCodeValue = anchor.getAttribute("data-value")?.toLowerCase();

    // Default URL based on country code
    let url = `https://www.atyabalmarshoud.com/en-${countryCodeValue}`;

    // Map keywords in label to URLs
    const regionMap = {
      "Qatar": "https://qa.atyabalmarshoud.com/en-qa",
      "Kuwait": "https://www.atyabalmarshoud.com",
      "Worldwide": "https://www.atyabalmarshoud.com",
      "European Union": "https://www.atyabalmarshoud.com/en-eu",
      "United Arab": "https://uae.atyabalmarshoud.com/en-ae",
      "Saudi Arabia": "https://ksa.atyabalmarshoud.com/en-ksa"
    };

    // Check if label text contains any of the keywords
    const labelText = label?.textContent || "";
    for (const key in regionMap) {
      if (labelText.includes(key)) {
        url = regionMap[key];
        break;
      }
    }

    listItems[i].innerHTML = listItems[i].innerHTML.replace(
      'href="#"',
      `href="${url}"`
    );

    if (label?.textContent?.includes("Jordan")) {
      hasJordanPopupOpened = false;
      // label.parentElement.addEventListener("click", () => {
      //   setTimeout(openJordanPopup, 500); // Popup with 500ms delay
      // });
    }
  }
};

const popup = document.getElementById(
  "shopify-section-sections--23593814786365__popup"
);

const popupShow = popup.getElementsByClassName("popup--popup")[0];
// Function to open the Jordan popup
const dismissIcon = popup?.getElementsByClassName("popup__dismiss-icon ")[0];
const closeBtn = popup?.getElementsByClassName("btn--text-link")[0];
// console.log(closeBtn, "closeBtn");

const openJordanPopup = () => {
  if (popup) {
    // Add CSS classes and styles to show popup and animations
    document.documentElement.classList.add("do-anim");

    popup.classList.add("animation--popup", "popup--size-medium");
    popup.style.visibility = "visible";
    popupShow.style.visibility = "visible";

    const popupContent = popup.querySelector(".popup__content");
    const popupWash = popup.querySelector(".popup__wash");

    if (popupContent) popupContent.style.opacity = "1";
    if (popupWash) popupWash.style.opacity = "1";

    const popupItems = popup.querySelectorAll(".animation--popup-item");
    popupItems.forEach((item) => (item.style.opacity = "1"));
    // hasJordanPopupOpened = false;

    if (dismissIcon) {
      dismissIcon.addEventListener("click", closeJordanPopup);
    }
    if (closeBtn) {
      closeBtn.addEventListener("click", closeJordanPopup);
    }
  } else {
    console.error("Popup element not found");
  }
};

const checkForJordanAndOpenPopup = () => {
  console.log("Page started");
  const currentURL = window.location.href;
  console.log(currentURL);
  const targetURL = "https://atyab-al-marshoud-qatar.myshopify.com/";
  const disclosureToggles =
    document.getElementsByClassName("disclosure__toggle");

  // console.log(currentURL, targetURL);

  if (currentURL === targetURL) {
    for (let i = 0; i < disclosureToggles.length; i++) {
      const elementText = disclosureToggles[i].innerText.trim();
      if (elementText === "Jordan ( USD )") {
        // Opening popup
        openJordanPopup();
        break;
      }
    }
  }
};

const closeJordanPopup = () => {
  console.log("closed--");
  popup.style.display = "none";
};

window.addEventListener("DOMContentLoaded", checkForJordanAndOpenPopup);
